import { ITranslatedFunction } from "@services/i18n"

export function getItemSelectionTitle(checked: boolean): ITranslatedFunction<string> {
	return (t) => {
		return checked ? t("itemActions.deselect") : t("itemActions.select")
	}
}
